import React from 'react';

interface PhoneMockupProps {
  children: React.ReactNode;
  className?: string;
  screenBackground?: string; // Custom background class for the screen (e.g., "bg-[#0b141a]" for WhatsApp)
}

export const PhoneMockup: React.FC<PhoneMockupProps> = ({ children, className = '', screenBackground }) => {
  const useCustomBackground = !!screenBackground;
  
  return (
    <div className={`relative ${className}`}>
      {/* Phone frame */}
      <div className="relative w-[280px] h-[560px] bg-gray-900 rounded-[3rem] p-3 shadow-2xl">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-gray-900 rounded-b-2xl z-20" />
        
        {/* Screen bezel */}
        <div className={`relative w-full h-full rounded-[2.25rem] overflow-hidden ${
          useCustomBackground ? screenBackground : 'bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900'
        }`}>
          {/* Status bar - only show if not using custom background */}
          {!useCustomBackground && (
            <div className="absolute top-0 left-0 right-0 h-8 flex items-center justify-between px-6 pt-1 z-10">
              <span className="text-white/80 text-xs font-medium">9:41</span>
              <div className="flex items-center gap-1">
                <div className="flex gap-0.5">
                  <div className="w-1 h-2.5 bg-white/80 rounded-sm" />
                  <div className="w-1 h-3 bg-white/80 rounded-sm" />
                  <div className="w-1 h-3.5 bg-white/80 rounded-sm" />
                  <div className="w-1 h-2 bg-white/40 rounded-sm" />
                </div>
                <div className="w-5 h-2.5 border border-white/80 rounded-sm ml-1">
                  <div className="w-3/4 h-full bg-white/80 rounded-sm" />
                </div>
              </div>
            </div>
          )}
          
          {/* Content area */}
          <div className={`absolute inset-0 overflow-hidden ${useCustomBackground ? '' : 'pt-10 pb-6 px-3'}`}>
            {children}
          </div>
          
          {/* Home indicator */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-32 h-1 bg-white/30 rounded-full z-10" />
        </div>
      </div>
    </div>
  );
};
